window.addEventListener("load", function () {
    document.querySelectorAll('.popup_getlist2 .btn_get').forEach(function(btn) {
        
        if (btn.classList.contains('received')) {
            btn.textContent = btn.getAttribute('data-text-success');
        } else {
            btn.textContent = btn.getAttribute('data-text');
        }
        
    });
});